import FormatItalicIcon from '@mui/icons-material/FormatItalicRounded';
import { LexicalEditor, FORMAT_TEXT_COMMAND } from 'lexical';
import { StyledButton } from '../../styles';
import { IS_APPLE } from '../../../../shared/environment';

interface Props {
  isItalic: boolean;
  isEditable: boolean;
  activeEditor: LexicalEditor;
}

export default function FormatItalicButton(props: Props) {
  const { isItalic, isEditable, activeEditor } = props;
  return (
    <StyledButton
      disabled={!isEditable}
      onClick={() => {
        activeEditor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic');
      }}
      className={`toolbar-item spaced ${isItalic ? 'active' : ''}`}
      title={IS_APPLE ? 'Italic (⌘I)' : 'Italic (Ctrl+I)'}
      type="button"
      aria-label={`Format text as italics. Shortcut: ${IS_APPLE ? '⌘I' : 'Ctrl+I'}`}
    >
      <FormatItalicIcon />
    </StyledButton>
  );
}
